<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''" style="min-height: 100%">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{errorMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{successMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-4">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            Sizes - {{ name || "No Size Selected" }}
          </h3>
        </div>
        <div class="col-md-8 text-right" style="padding-bottom: 6px;">
          <!-- <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
            </template>
          </base-dropdown> -->
          <div v-if="serverType == 'ho' && accessRights.includes('A')">
            <div v-if="parentId > 0">
              <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">
                + Add Size
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
      <div v-else>
        <size-form  @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></size-form>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" @vuetable:load-error="onLoadError"
        @vuetable:pagination-data="onPaginationData" >
        <template slot="actions" slot-scope="props">
          <center>
            <div v-if="serverType == 'ho'" class="table-button-container">
              <button v-if="accessRights.includes('V')" id="view" class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)">View</button>
              <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
              <a-popconfirm v-if="accessRights.includes('D')" title="You are about to delete this record?" @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                <a class="btn btn-danger btn-sm text-white">Delete</a>
              </a-popconfirm>
            </div>
            <div v-else class="table-button-container">
              <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from "axios";
  import {
    mapState,
    mapActions
  } from 'vuex'
  import SizeForm from '../Product Profiles V2/SizeForm.vue';
  import ImportProfile from "../ImportProfile";
  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String,
      name: String
    },
    components: {
      Vuetable,
      VuetablePagination,
      SizeForm,
      ImportProfile
    },
    computed: {
      ...mapState(['endPoint', 'profileId', 'parentId', 'serverType']),
    },
    watch: {
      parentId: function () {
        this.apiURL = this.apiURL = this.endPoint + 'sizes?' + 'size_group_id=' + this.parentId;
      }
    },
    data() {
      return {
        viewMode: false,
        accessRights: [],
        filterStatus: "",
        profileAction: "",
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        drawerVisible: false,
        profileAction:null,
        visible: false,
        apiURL: "",
        fields: ["id", "name", '__slot:actions'],
        sortOrder: [{
          field: "name",
          direction: "asc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        },
        sizeGroupName: ""
      }
    },
    methods: {
      ...mapActions(['updateProfileId']),
      closeDrawer(){
        this.onClose()
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      showDrawer(id) {
        if(event.target.id == "view"){
            this.viewMode = true
        } else {
            this.viewMode = false
        }
        this.componentKey++
        this.updateProfileId(id)
        this.visible = true
      },
      onClose() {
        this.drawerVisible = false
        this.profileAction = null
        this.visible = false
        this.componentKey++
      },
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      deleteRow(id) {
        axios({
            method: 'delete',
            url: this.endPoint + 'sizes' + '/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            },
          })
          .then(function () {
            component_x.successMessage = "Successfully deleted record"
            component_x.$refs.vuetable.refresh()
          })
          .catch(function () {
            alert("Invalid Credentials")
          });
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async showActionDrawer(action) {
        this.profileAction = action;
        this.visible = true;
      },
    },
    mounted: function () {
      component_x = this;
      this.accessRights = this.$attrs.accessRights;
      this.name = ''
    }
  }
</script>

<style>
</style>
